// Shared presentation helpers for home sections.
import { GAME_GRADIENTS, GAME_GLOW } from '../../theme/theme';

export { GAME_GRADIENTS, GAME_GLOW };
export const RANK_MEDAL = { 1: '🥇', 2: '🥈', 3: '🥉' };

export function timeAgo(ts) {
  if (!ts) return '';
  const ms = ts.toMillis ? ts.toMillis() : (typeof ts === 'number' ? ts : Date.now());
  const seconds = Math.floor((Date.now() - ms) / 1000);
  if (seconds < 60) return 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  if (days < 30) return `${Math.floor(days / 7)}w ago`;
  if (days < 365) return `${Math.floor(days / 30)}mo ago`;
  return `${Math.floor(days / 365)}y ago`;
}

export function nameColor(name) {
  const hue = [...(name || 'x')].reduce((acc, c) => acc + c.charCodeAt(0), 0) % 360;
  return `hsl(${hue}, 70%, 60%)`;
}

// ─── Background ───────────────────────────────────────────────────────────────
